{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "HEADER": "Shopify",
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Prekliči",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integracije",
    "DESCRIPTION": "Chatwoot se povezuje z več orodji in storitvami za izboljšanje učinkovitosti vaše ekipe. Raziščite spodnji seznam za konfiguracijo vaših priljubljenih aplikacij.",
    "LEARN_MORE": "Izvedite več o integracijah",
    "LOADING": "Pridobivanje integracij",
    "SEARCH_PLACEHOLDER": "Search integrations...",
    "NO_RESULTS": "No integrations found matching your search",
    "CAPTAIN": {
      "DISABLED": "Captain ni omogočen na vašem računu.",
      "CLICK_HERE_TO_CONFIGURE": "Kliknite tukaj za konfiguracijo",
      "LOADING_CONSOLE": "Nalaganje konzole Captain...",
      "FAILED_TO_LOAD_CONSOLE": "Nalaganje konzole Captain ni uspelo. Osvežite stran in poskusite znova."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Naročeni dogodki",
      "LEARN_MORE": "Izvedite več o webhook",
      "PAYWALL": {
        "TITLE": "Webhooks are available on paid plans",
        "AVAILABLE_ON": "Use webhooks to receive real-time events from your Chatwoot account.",
        "UPGRADE_PROMPT": "Upgrade to the Startups, Business, or Enterprise plan to use webhooks.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "Change or cancel your plan anytime."
      },
      "SECRET": {
        "LABEL": "Secret",
        "COPY": "Copy secret to clipboard",
        "COPY_SUCCESS": "Secret copied to clipboard",
        "TOGGLE": "Toggle secret visibility",
        "CREATED_DESC": "Your webhook has been created. Use the secret below to verify webhook signatures. Please copy it now — you can also find it later in the webhook edit form.",
        "DONE": "Done"
      },
      "COUNT": "{n} webhook | {n} webhooks",
      "SEARCH_PLACEHOLDER": "Search webhooks...",
      "NO_RESULTS": "No webhooks found matching your search",
      "FORM": {
        "CANCEL": "Prekliči",
        "DESC": "Webhook dogodki vam zagotavljajo informacije v realnem času o dogajanju v vašem računu Chatwoot. Prosimo, vnesite veljaven URL za nastavitev povratnega klica.",
        "SUBSCRIPTIONS": {
          "LABEL": "Dogodki",
          "EVENTS": {
            "CONVERSATION_CREATED": "Ustvarjen pogovor",
            "CONVERSATION_STATUS_CHANGED": "Status pogovora spremenjen",
            "CONVERSATION_UPDATED": "Pogovor posodobljen",
            "MESSAGE_CREATED": "Sporočilo ustvarjeno",
            "MESSAGE_UPDATED": "Sporočilo posodobljeno",
            "WEBWIDGET_TRIGGERED": "Uporabnik je odprl pripomoček za klepet v živo",
            "CONTACT_CREATED": "Kontakt ustvarjen",
            "CONTACT_UPDATED": "Kontakt posodobljen",
            "CONVERSATION_TYPING_ON": "Conversation Typing On",
            "CONVERSATION_TYPING_OFF": "Conversation Typing Off",
            "INBOX_UPDATED": "Inbox updated"
          }
        },
        "NAME": {
          "LABEL": "Webhook Name",
          "PLACEHOLDER": "Enter the name of the webhook"
        },
        "END_POINT": {
          "LABEL": "URL spletnega ključa",
          "PLACEHOLDER": "Primer: {webhookExampleURL}",
          "ERROR": "Prosimo, vnesite veljaven URL"
        },
        "EDIT_SUBMIT": "Posodobi spletni ključ",
        "ADD_SUBMIT": "Ustvari spletni ključ"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Konfiguriraj",
      "HEADER": "Nastavitve webhook",
      "HEADER_BTN_TXT": "Dodaj nov webhook",
      "LOADING": "Pridobivanje pripetih webhook",
      "SEARCH_404": "Ni elementov, ki bi ustrezali temu iskanju",
      "SIDEBAR_TXT": "<p><b>Webhook</b> </p> <p>Webhook so HTTP povratni klici, ki jih je mogoče definirati za vsak račun. Aktivirajo se ob dogodkih, kot je ustvarjanje sporočila v Chatwoot. Za ta račun lahko ustvarite več kot en webhook. <br /><br /> Za ustvarjanje <b>webhooka</b> kliknite na gumb <b>Dodaj nov webhook</b>. Obstoječe webhook lahko odstranite s klikom na gumb Izbriši.</p>",
      "LIST": {
        "404": "Za ta račun niso konfigurirani nobeni webhook",
        "TITLE": "Upravljanje webhook",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Končna točka spletnega klica",
          "ACTIONS": "Dejanja"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Uredi",
        "TITLE": "Uredi webhook",
        "API": {
          "SUCCESS_MESSAGE": "Konfiguracija spletnega ključa je bila uspešno posodobljena",
          "ERROR_MESSAGE": "Povezava s strežnikom Woot ni uspela, prosimo poskusite znova kasneje"
        }
      },
      "ADD": {
        "CANCEL": "Prekliči",
        "TITLE": "Dodaj nov webhook",
        "API": {
          "SUCCESS_MESSAGE": "Konfiguracija spletnega ključa je bila uspešno dodana",
          "ERROR_MESSAGE": "Povezava s strežnikom Woot ni uspela, prosimo, poskusite znova kasneje"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Izbriši",
        "API": {
          "SUCCESS_MESSAGE": "Webhook je bil uspešno izbrisan",
          "ERROR_MESSAGE": "Povezava s strežnikom Woot ni uspela, prosimo, poskusite znova kasneje"
        },
        "CONFIRM": {
          "TITLE": "Potrdite brisanje",
          "MESSAGE": "Ste prepričani, da želite izbrisati webhook? ({webhookURL})",
          "YES": "Da, izbriši ",
          "NO": "Ne, obdrži"
        }
      }
    },
    "SLACK": {
      "HEADER": "Slack",
      "DELETE": "Izbriši",
      "DELETE_CONFIRMATION": {
        "TITLE": "Izbriši integracijo",
        "MESSAGE": "Ali ste prepričani, da želite izbrisati integracijo? S tem boste izgubili dostop do pogovorov v vašem Slack delovnem prostoru."
      },
      "HELP_TEXT": {
        "TITLE": "Kako uporabljati Slack integracijo?",
        "BODY": "S to integracijo se vsi dohodni pogovori sinhronizirajo v kanal ***{selectedChannelName}*** v vašem delovnem prostoru. Pogovore s strankami lahko upravljate neposredno v tem kanalu, zato ne spregledate nobenega sporočila.\n\nTukaj so glavne funkcije integracije:\n\n**Odgovarjanje na pogovore iz kanala:** Če želite odgovoriti na pogovor v kanalu ***{selectedChannelName}***, preprosto napišite sporočilo in ga pošljite kot nit. Tako se odgovor samodejno pošlje stranki. Tako preprosto je!\n\n**Ustvarjanje zasebnih opomb:** Če želite ustvariti zasebne opombe namesto odgovorov, začnite sporočilo z ***`note:`***. Tako sporočilo ostane zasebno in stranki ni vidno.\n\n**Povezava s profilom agenta:** Če ima oseba, ki odgovori v kanalu, profil agenta z istim naslovom elektronske pošte, se odgovori samodejno povežejo s tem profilom. Tako lahko preprosto spremljate, kdo je kaj napisal in kdaj. Če odgovarja oseba brez povezanega profila agenta, se odgovori stranki prikažejo iz privzetega profila.",
        "SELECTED": "izbrano"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Izberite kanal",
        "UPDATE": "Posodobi",
        "BUTTON_TEXT": "Poveži kanal",
        "DESCRIPTION": "Vaš Slack delovni prostor je zdaj povezan s Chatwoot. Vendar pa je integracija trenutno neaktivna. Za aktivacijo integracije in povezavo kanala s Chatwoot, prosimo, kliknite spodnji gumb.\n\n**Opomba:** Če poskušate povezati zasebni kanal, najprej dodajte aplikacijo Chatwoot v Slack kanal, preden nadaljujete s tem korakom.",
        "ATTENTION_REQUIRED": "Potrebna pozornost",
        "EXPIRED": "Vaša integracija Slack je potekla. Če želite še naprej prejemati sporočila na Slack, prosimo, izbrišite integracijo in znova povežite delovno okolje."
      },
      "UPDATE_ERROR": "Pri posodabljanju integracije je prišlo do napake, prosimo poskusite znova",
      "UPDATE_SUCCESS": "Kanal je uspešno povezan",
      "FAILED_TO_FETCH_CHANNELS": "Pri pridobivanju kanalov iz Slack je prišlo do napake, prosimo poskusite znova"
    },
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Kliknite tukaj za pridružitev",
      "LEAVE_THE_ROOM": "Zapusti sobo",
      "START_VIDEO_CALL_HELP_TEXT": "Začni nov video klic s stranko",
      "JOIN_ERROR": "Prišlo je do napake pri pridruževanju klica, prosimo, poskusite znova",
      "CREATE_ERROR": "Prišlo je do napake pri ustvarjanju povezave za sestanek, prosimo, poskusite znova"
    },
    "OPEN_AI": {
      "AI_ASSIST": "Pomoč AI",
      "WITH_AI": " {option} z AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Predlog odgovora",
        "SUMMARIZE": "Povzetek",
        "REPHRASE": "Izboljšaj pisanje",
        "FIX_SPELLING_GRAMMAR": "Popravi črkovanje in slovnico",
        "SHORTEN": "Skrajšaj",
        "EXPAND": "Razširi",
        "MAKE_FRIENDLY": "Spremeni ton sporočila v prijazen",
        "MAKE_FORMAL": "Uporabi formalen ton",
        "SIMPLIFY": "Poenostavi",
        "CONFIDENT": "Use confident tone",
        "PROFESSIONAL": "Use professional tone",
        "CASUAL": "Use casual tone",
        "STRAIGHTFORWARD": "Use straightforward tone"
      },
      "REPLY_OPTIONS": {
        "IMPROVE_REPLY": "Improve reply",
        "IMPROVE_REPLY_SELECTION": "Improve the selection",
        "CHANGE_TONE": {
          "TITLE": "Change tone",
          "OPTIONS": {
            "PROFESSIONAL": "Professional",
            "CASUAL": "Casual",
            "STRAIGHTFORWARD": "Straightforward",
            "CONFIDENT": "Confident",
            "FRIENDLY": "Friendly"
          }
        },
        "GRAMMAR": "Fix grammar & spelling",
        "SUGGESTION": "Suggest a reply",
        "SUMMARIZE": "Summarize the conversation",
        "ASK_COPILOT": "Ask Copilot"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Osnutek vsebine",
        "GENERATED_TITLE": "Generirana vsebina",
        "AI_WRITING": "AI piše",
        "BUTTONS": {
          "APPLY": "Uporabi ta predlog",
          "CANCEL": "Prekliči"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrirajte z OpenAI",
        "DESC": "Dodajte napredne AI funkcije na svojo nadzorno ploščo z GPT modeli OpenAI. Za začetek vnesite API ključ iz svojega OpenAI računa.",
        "KEY_PLACEHOLDER": "Vnesite svoj OpenAI API ključ",
        "BUTTONS": {
          "NEED_HELP": "Potrebujete pomoč?",
          "DISMISS": "Zapri",
          "FINISH": "Dokončaj nastavitev"
        },
        "DISMISS_MESSAGE": "Integracijo OpenAI lahko nastavite kadarkoli pozneje.",
        "SUCCESS_MESSAGE": "Integracija OpenAI je bila uspešno nastavljena"
      },
      "TITLE": "Izboljšaj z AI",
      "SUMMARY_TITLE": "Povzetek z AI",
      "REPLY_TITLE": "Predlog odgovora z AI",
      "SUBTITLE": "Izboljšan odgovor bo ustvarjen z uporabo AI, na podlagi vašega trenutnega osnutka.",
      "TONE": {
        "TITLE": "Ton",
        "OPTIONS": {
          "PROFESSIONAL": "Profesionalno",
          "FRIENDLY": "Prijazno"
        }
      },
      "BUTTONS": {
        "GENERATE": "Ustvari",
        "GENERATING": "Ustvarjam...",
        "CANCEL": "Prekliči"
      },
      "GENERATE_ERROR": "Pri obdelavi vsebine je prišlo do napake, prosimo, preverite svoj OpenAI API ključ in poskusite znova"
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Integracija je bila uspešno izbrisana"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Poveži"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Aplikacije nadzorne plošče",
      "HEADER_BTN_TXT": "Dodaj novo aplikacijo nadzorne plošče",
      "SIDEBAR_TXT": "<p><b>Aplikacije nadzorne plošče</b></p><p>Aplikacije nadzorne plošče omogočajo organizacijam, da vgradijo aplikacijo znotraj Chatwoot nadzorne plošče, da zagotovijo kontekst za agente za podporo strankam. Ta funkcija vam omogoča, da neodvisno ustvarite aplikacijo in jo vgradite v nadzorno ploščo za prikaz informacij o uporabniku, njihovih naročilih ali pretekli zgodovini plačil.</p><p>Ko vgradite svojo aplikacijo z uporabo nadzorne plošče v Chatwoot, bo vaša aplikacija prejela kontekst pogovora in stika kot dogodek okna. Na svoji strani implementirajte poslušalca za dogodek sporočila, da prejmete kontekst.</p><p>Za dodajanje nove aplikacije nadzorne plošče kliknite na gumb 'Dodaj novo aplikacijo nadzorne plošče'.</p>",
      "DESCRIPTION": "Aplikacije nadzorne plošče omogočajo organizacijam, da vgradijo aplikacijo znotraj nadzorne plošče, da zagotovijo kontekst za agente za podporo strankam. Ta funkcija vam omogoča, da neodvisno ustvarite aplikacijo in jo vgradite za prikaz informacij o uporabniku, njihovih naročilih ali pretekli zgodovini plačil.",
      "LEARN_MORE": "Izvedite več o aplikacijah nadzorne plošče",
      "COUNT": "{n} dashboard app | {n} dashboard apps",
      "SEARCH_PLACEHOLDER": "Search dashboard apps...",
      "NO_RESULTS": "No dashboard apps found matching your search",
      "LIST": {
        "404": "Na tem računu še ni konfiguriranih aplikacij nadzorne plošče",
        "LOADING": "Pridobivanje aplikacij nadzorne plošče...",
        "TABLE_HEADER": {
          "NAME": "Ime",
          "ENDPOINT": "Končna točka",
          "ACTIONS": "Actions"
        },
        "EDIT_TOOLTIP": "Uredi aplikacijo",
        "DELETE_TOOLTIP": "Izbriši aplikacijo"
      },
      "FORM": {
        "TITLE_LABEL": "Ime",
        "TITLE_PLACEHOLDER": "Vnesite ime za vašo aplikacijo nadzorne plošče",
        "TITLE_ERROR": "Ime za aplikacijo nadzorne plošče je obvezno",
        "URL_LABEL": "Končna točka",
        "URL_PLACEHOLDER": "Vnesite URL končne točke, kjer je gostovana vaša aplikacija",
        "URL_ERROR": "Zahtevan je veljaven URL"
      },
      "CREATE": {
        "HEADER": "Dodaj novo aplikacijo nadzorne plošče",
        "FORM_SUBMIT": "Pošlji",
        "FORM_CANCEL": "Prekliči",
        "API_SUCCESS": "Aplikacija nadzorne plošče je bila uspešno konfigurirana",
        "API_ERROR": "Aplikacije nismo mogli ustvariti. Poskusite znova kasneje"
      },
      "UPDATE": {
        "HEADER": "Uredi aplikacijo nadzorne plošče",
        "FORM_SUBMIT": "Posodobi",
        "FORM_CANCEL": "Prekliči",
        "API_SUCCESS": "Aplikacija nadzorne plošče je bila uspešno posodobljena",
        "API_ERROR": "Aplikacije ni bilo mogoče posodobiti. Poskusite znova kasneje"
      },
      "DELETE": {
        "CONFIRM_YES": "Da, izbriši",
        "CONFIRM_NO": "Ne, obdrži",
        "TITLE": "Potrdite brisanje",
        "MESSAGE": "Ste prepričani, da želite izbrisati aplikacijo {appName}?",
        "API_SUCCESS": "Aplikacija nadzorne plošče je bila uspešno izbrisana",
        "API_ERROR": "Aplikacije nismo mogli izbrisati. Poskusite znova kasneje"
      }
    },
    "LINEAR": {
      "HEADER": "Linear",
      "ADD_OR_LINK_BUTTON": "Ustvari/poveži Linear težavo",
      "LOADING": "Pridobivanje linearnih težav...",
      "LOADING_ERROR": "Prišlo je do napake pri pridobivanju linearnih težav, prosimo, poskusite znova",
      "CREATE": "Ustvari",
      "LINK": {
        "SEARCH": "Išči težave",
        "SELECT": "Izberite težavo",
        "TITLE": "Povezava",
        "EMPTY_LIST": "Ni najdenih linearnih težav",
        "LOADING": "Nalaganje",
        "ERROR": "Prišlo je do napake pri pridobivanju linearnih težav, poskusite znova",
        "LINK_SUCCESS": "Zadeva je bila uspešno povezana",
        "LINK_ERROR": "Pri povezovanju zadeve je prišlo do napake, prosimo, poskusite znova",
        "LINK_TITLE": "Pogovor (#{conversationId}) z {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Ustvari/poveži Linear zadevo",
        "DESCRIPTION": "Ustvarjajte Linear zadeve iz pogovorov ali povežite obstoječe za nemoteno sledenje.",
        "FORM": {
          "TITLE": {
            "LABEL": "Naslov",
            "PLACEHOLDER": "Vnesite naslov",
            "REQUIRED_ERROR": "Naslov je obvezen"
          },
          "DESCRIPTION": {
            "LABEL": "Opis",
            "PLACEHOLDER": "Vnesite opis"
          },
          "TEAM": {
            "LABEL": "Ekipa",
            "PLACEHOLDER": "Izberi ekipo",
            "SEARCH": "Išči ekipo",
            "REQUIRED_ERROR": "Ekipa je obvezna"
          },
          "ASSIGNEE": {
            "LABEL": "Prejemnik",
            "PLACEHOLDER": "Izberi dodeljenca",
            "SEARCH": "Išči dodeljenca"
          },
          "PRIORITY": {
            "LABEL": "Prioriteta",
            "PLACEHOLDER": "Izberi prednost",
            "SEARCH": "Išči prioriteto"
          },
          "LABEL": {
            "LABEL": "Oznaka",
            "PLACEHOLDER": "Izberi oznako",
            "SEARCH": "Išči oznako"
          },
          "STATUS": {
            "LABEL": "Stanje",
            "PLACEHOLDER": "Izberi status",
            "SEARCH": "Išči status"
          },
          "PROJECT": {
            "LABEL": "Projekt",
            "PLACEHOLDER": "Izberite projekt",
            "SEARCH": "Išči projekt"
          }
        },
        "CREATE": "Ustvari",
        "CANCEL": "Prekliči",
        "CREATE_SUCCESS": "Zadeva je bila uspešno ustvarjena",
        "CREATE_ERROR": "Pri ustvarjanju zadeve je prišlo do napake, prosimo, poskusite znova",
        "LOADING_TEAM_ERROR": "Pri pridobivanju ekip je prišlo do napake, prosimo, poskusite znova",
        "LOADING_TEAM_ENTITIES_ERROR": "Pri pridobivanju entitet ekipe je prišlo do napake, prosimo, poskusite znova"
      },
      "ISSUE": {
        "STATUS": "Stanje",
        "PRIORITY": "Prioriteta",
        "ASSIGNEE": "Prejemnik",
        "LABELS": "Oznake",
        "CREATED_AT": "Ustvarjeno ob {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Prekini povezavo",
        "SUCCESS": "Zadeva je bila uspešno odvezana",
        "ERROR": "Prišlo je do napake pri odvzemu povezave z zadevo, prosimo, poskusite znova"
      },
      "NO_LINKED_ISSUES": "No linked issues found",
      "DELETE": {
        "TITLE": "Ali ste prepričani, da želite izbrisati integracijo?",
        "MESSAGE": "Ali ste prepričani, da želite izbrisati integracijo?",
        "CONFIRM": "Da, izbriši",
        "CANCEL": "Prekliči"
      },
      "CTA": {
        "TITLE": "Connect to Linear",
        "AGENT_DESCRIPTION": "Linear workspace is not connected. Request your administrator to connect a workspace to use this integration.",
        "DESCRIPTION": "Linear workspace is not connected. Click the button below to connect your workspace to use this integration.",
        "BUTTON_TEXT": "Connect Linear workspace"
      }
    },
    "NOTION": {
      "HEADER": "Notion",
      "DELETE": {
        "TITLE": "Are you sure you want to delete the Notion integration?",
        "MESSAGE": "Deleting this integration will remove access to your Notion workspace and stop all related functionality.",
        "CONFIRM": "Da, izbriši",
        "CANCEL": "Cancel"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Kapitan",
    "HEADER_KNOW_MORE": "Izvedi več",
    "OVERVIEW": {
      "HEADER": "Pregled",
      "WELCOME": {
        "LABEL": "Captain summary",
        "LOADING": "Generating summary…"
      },
      "INBOX_BANNER": {
        "TEXT": "This assistant isn't connected to any inbox yet, so it won't respond to conversations.",
        "ACTION": "Connect inbox",
        "DISMISS": "Dismiss"
      },
      "COVERAGE_BANNER": {
        "TEXT": "{count} FAQs are pending review, keeping coverage at {coverage}%. Approve them so your assistant can resolve more on its own.",
        "ACTION": "Review FAQs",
        "DISMISS": "Dismiss"
      },
      "RANGES": {
        "LAST_DAYS": "Last {count} days",
        "THIS_MONTH": "This month",
        "LAST_MONTH": "Last month"
      },
      "METRICS": {
        "HANDLED": {
          "LABEL": "Conversations handled",
          "HINT": "Distinct conversations this assistant replied in."
        },
        "AUTO_RESOLUTION": {
          "LABEL": "Auto-resolution rate",
          "HINT": "Share of handled conversations closed without a human reply."
        },
        "HANDOFF": {
          "LABEL": "Handoff rate",
          "HINT": "Share of handled conversations escalated to a human agent."
        },
        "HOURS_SAVED": {
          "LABEL": "Time saved",
          "HINT": "Estimate: Captain replies times ~2 minutes of assumed agent effort per reply. Directional, not measured labor."
        },
        "REOPEN": {
          "LABEL": "Reopen rate",
          "HINT": "Auto-resolved conversations that were reopened afterwards."
        },
        "DEPTH": {
          "LABEL": "Messages / conversation",
          "HINT": "Average replies the assistant sends per conversation."
        }
      },
      "DRILLDOWN": {
        "CLOSE": "Close details",
        "EMPTY": "No records found for this metric.",
        "ERROR": "Could not load records. Please try again.",
        "LOAD_MORE": "Load more",
        "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations"
      },
      "KNOWLEDGE": {
        "TITLE": "Knowledge coverage",
        "COVERAGE": "{pct}% approved",
        "APPROVED": "Approved FAQs",
        "PENDING": "Pending FAQs",
        "DOCUMENTS": "Dokumenti"
      },
      "LINKS": {
        "DOCS": {
          "TITLE": "Captain docs",
          "DESCRIPTION": "Guides and how-tos for Captain"
        },
        "PLAYGROUND": {
          "TITLE": "Poligon",
          "DESCRIPTION": "Test this assistant's replies"
        },
        "BILLING": {
          "TITLE": "Računovodstvo",
          "DESCRIPTION": "Manage credits and plan"
        }
      }
    },
    "ASSISTANT_SWITCHER": {
      "ASSISTANTS": "Pomočniki",
      "SWITCH_ASSISTANT": "Preklapljanje med pomočniki",
      "NEW_ASSISTANT": "Ustvari pomočnika",
      "EMPTY_LIST": "Nobenega pomočnika ni bilo mogoče najti, prosimo, ustvarite enega za začetek"
    },
    "COPILOT": {
      "TITLE": "Copilot",
      "TRY_THESE_PROMPTS": "Try these prompts",
      "PANEL_TITLE": "Začnite s Copilotom",
      "KICK_OFF_MESSAGE": "Potrebujete hitro povzetek, želite preveriti pretekle pogovore ali sestaviti boljši odgovor? Copilot je tu, da pospeši delo.",
      "SEND_MESSAGE": "Pošlji sporočilo...",
      "EMPTY_MESSAGE": "Pri generiranju odgovora je prišlo do napake. Prosimo, poskusite znova.",
      "LOADER": "Kapitan razmišlja",
      "YOU": "Vi",
      "USE": "Uporabi to",
      "RESET": "Ponastavi",
      "SHOW_STEPS": "Pokaži korake",
      "SELECT_ASSISTANT": "Izberi pomočnika",
      "PROMPTS": {
        "SUMMARIZE": {
          "LABEL": "Povzetek tega pogovora",
          "CONTENT": "Povzemi ključne točke, o katerih sta se pogovarjala stranka in agent podpore, vključno s strankinimi skrbmi, vprašanji ter rešitvami ali odgovori agenta podpore."
        },
        "SUGGEST": {
          "LABEL": "Predlagaj odgovor",
          "CONTENT": "Analiziraj povpraševanje stranke in sestavi odgovor, ki učinkovito rešuje njihova vprašanja ali pomisleke. Poskrbi, da je odgovor jasen, jedrnat in vsebuje koristne informacije."
        },
        "RATE": {
          "LABEL": "Ocenite ta pogovor",
          "CONTENT": "Preglej pogovor, da oceniš, kako dobro izpolnjuje potrebe stranke. Deli oceno od 1 do 5 glede na ton, jasnost in učinkovitost."
        },
        "HIGH_PRIORITY": {
          "LABEL": "Pogovori z visoko prioriteto",
          "CONTENT": "Naredi povzetek vseh odprtih pogovorov z visoko prioriteto. Vključi ID pogovora, ime stranke (če je na voljo), vsebino zadnjega sporočila in dodeljenega agenta. Po potrebi združi po statusu."
        },
        "LIST_CONTACTS": {
          "LABEL": "Našteti stike",
          "CONTENT": "Pokaži seznam top 10 stikov. Vključi ime, e-pošto ali telefonsko številko (če je na voljo), čas zadnjega vpogleda, oznake (če obstajajo)."
        }
      }
    },
    "PLAYGROUND": {
      "USER": "Vi",
      "ASSISTANT": "Pomočnik",
      "MESSAGE_PLACEHOLDER": "Vnesite svoje sporočilo...",
      "HEADER": "Poligon",
      "DESCRIPTION": "Uporabi ta poligon za pošiljanje sporočil svojemu pomočniku in preveri, ali odgovarja natančno, hitro in v pričakovanem tonu.",
      "CREDIT_NOTE": "Sporočila, poslana tukaj, se bodo štela v vaše Captain kredite."
    },
    "PAYWALL": {
      "TITLE": "Nadgradite za uporabo Captain AI",
      "AVAILABLE_ON": "Captain ni na voljo v brezplačnem paketu.",
      "UPGRADE_PROMPT": "Nadgradite svoj paket, da pridobite dostop do naših pomočnikov, copilot in še več.",
      "UPGRADE_NOW": "Nadgradi zdaj",
      "CANCEL_ANYTIME": "Paket lahko kadarkoli spremenite ali prekličete"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI je na voljo samo v Enterprise paketih.",
      "UPGRADE_PROMPT": "Nadgradite svoj paket, da pridobite dostop do naših pomočnikov, copilot in še več.",
      "ASK_ADMIN": "Prosimo, obrnite se na svojega skrbnika za nadgradnjo."
    },
    "BANNER": {
      "RESPONSES": "Uporabili ste več kot 80 % svojega limita odgovorov. Za nadaljevanje uporabe Captain AI prosimo nadgradite.",
      "DOCUMENTS": "Dosežen je limit dokumentov. Za nadaljevanje uporabe Captain AI nadgradite."
    },
    "FORM": {
      "CANCEL": "Prekliči",
      "CREATE": "Ustvari",
      "EDIT": "Posodobi"
    },
    "ASSISTANTS": {
      "HEADER": "Pomočniki",
      "NO_ASSISTANTS_AVAILABLE": "There are no assistants available in your account.",
      "ADD_NEW": "Ustvari novega pomočnika",
      "DELETE": {
        "TITLE": "Ste prepričani, da želite izbrisati pomočnika?",
        "DESCRIPTION": "Ta dejanje je trajno. Brisanje tega pomočnika bo odstranilo iz vseh povezanih poštnih predalov in trajno izbrisalo vse ustvarjeno znanje.",
        "CONFIRM": "Da, izbriši",
        "SUCCESS_MESSAGE": "Pomočnik je bil uspešno izbrisan",
        "ERROR_MESSAGE": "Prišlo je do napake pri brisanju asistenta, prosimo, poskusite znova."
      },
      "FORM_DESCRIPTION": "Izpolnite spodnje podatke, da poimenujete asistenta, opišete njegov namen in določite izdelek, ki ga bo podpiral.",
      "CREATE": {
        "TITLE": "Ustvari asistenta",
        "SUCCESS_MESSAGE": "Asistent je bil uspešno ustvarjen",
        "ERROR_MESSAGE": "Prišlo je do napake pri ustvarjanju asistenta, prosimo, poskusite znova."
      },
      "FORM": {
        "UPDATE": "Update",
        "SECTIONS": {
          "BASIC_INFO": "Basic Information",
          "SYSTEM_MESSAGES": "System Messages",
          "INSTRUCTIONS": "Instructions",
          "FEATURES": "Features",
          "TOOLS": "Tools "
        },
        "NAME": {
          "LABEL": "Name",
          "PLACEHOLDER": "Enter assistant name",
          "ERROR": "The name is required"
        },
        "DESCRIPTION": {
          "LABEL": "Description",
          "PLACEHOLDER": "Enter assistant description",
          "ERROR": "The description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Ime izdelka",
          "PLACEHOLDER": "Enter product name",
          "ERROR": "The product name is required"
        },
        "WELCOME_MESSAGE": {
          "LABEL": "Welcome Message",
          "PLACEHOLDER": "Enter welcome message"
        },
        "HANDOFF_MESSAGE": {
          "LABEL": "Handoff Message",
          "PLACEHOLDER": "Enter handoff message"
        },
        "RESOLUTION_MESSAGE": {
          "LABEL": "Resolution Message",
          "PLACEHOLDER": "Enter resolution message"
        },
        "INSTRUCTIONS": {
          "LABEL": "Instructions",
          "PLACEHOLDER": "Enter instructions for the assistant"
        },
        "FEATURES": {
          "TITLE": "Funkcije",
          "ALLOW_CONVERSATION_FAQS": "Ustvari pogosta vprašanja iz rešenih pogovorov",
          "ALLOW_MEMORIES": "Zajemite ključne podrobnosti kot spomine iz interakcij s strankami.",
          "ALLOW_CITATIONS": "Include source citations in responses",
          "ALLOW_CONTACT_ATTRIBUTES": "Allow access to contact information"
        }
      },
      "EDIT": {
        "TITLE": "Posodobi asistenta",
        "SUCCESS_MESSAGE": "Asistent je bil uspešno posodobljen",
        "ERROR_MESSAGE": "Prišlo je do napake pri posodabljanju asistenta, prosimo, poskusite znova.",
        "NOT_FOUND": "Could not find the assistant. Please try again."
      },
      "SETTINGS": {
        "HEADER": "Settings",
        "BASIC_SETTINGS": {
          "TITLE": "Basic settings",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "SYSTEM_SETTINGS": {
          "TITLE": "System settings",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "CONTROL_ITEMS": {
          "TITLE": "The Fun Stuff",
          "DESCRIPTION": "Add more control to the assistant. (a bit more visual like a story : Query guardrail → scenarios → output) Nudges user to actually utilise these.",
          "OPTIONS": {
            "GUARDRAILS": {
              "TITLE": "Guardrails",
              "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic."
            },
            "RESPONSE_GUIDELINES": {
              "TITLE": "Response guidelines",
              "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?"
            }
          }
        },
        "DELETE": {
          "TITLE": "Delete Assistant",
          "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
          "BUTTON_TEXT": "Delete {assistantName}"
        }
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Uredi asistenta",
        "DELETE_ASSISTANT": "Izbriši asistenta",
        "VIEW_CONNECTED_INBOXES": "Poglej povezane mape Prejeto"
      },
      "EMPTY_STATE": {
        "TITLE": "Ni na voljo pomočnikov",
        "SUBTITLE": "Ustvarite asistenta, ki bo vašim uporabnikom zagotavljal hitre in natančne odgovore. Lahko se uči iz vaših pomožnih člankov in preteklih pogovorov.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain asistent se neposredno povezuje s strankami, se uči iz vaših pomožnih dokumentov in preteklih pogovorov ter zagotavlja takojšnje, natančne odgovore. Obvladuje začetna vprašanja in nudi hitre rešitve, preden po potrebi prenese zadevo agentu."
        }
      },
      "GUARDRAILS": {
        "TITLE": "Guardrails",
        "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic.",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Delete"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example guardrails",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another guardrail..."
          },
          "NEW": {
            "TITLE": "Add a guardrail",
            "CREATE": "Create",
            "CANCEL": "Cancel",
            "PLACEHOLDER": "Type in another guardrail...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Iskanje ..."
        },
        "EMPTY_MESSAGE": "No guardrails found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No guardrails found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Guardrails added successfully",
            "ERROR": "There was an error adding guardrails, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Guardrails updated successfully",
            "ERROR": "There was an error updating guardrails, please try again."
          },
          "DELETE": {
            "SUCCESS": "Guardrails deleted successfully",
            "ERROR": "There was an error deleting guardrails, please try again."
          }
        }
      },
      "RESPONSE_GUIDELINES": {
        "TITLE": "Response Guidelines",
        "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Delete"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example response guidelines",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another response guideline..."
          },
          "NEW": {
            "TITLE": "Add a response guideline",
            "CREATE": "Create",
            "CANCEL": "Cancel",
            "PLACEHOLDER": "Type in another response guideline...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Iskanje ..."
        },
        "EMPTY_MESSAGE": "No response guidelines found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No response guidelines found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Response Guidelines added successfully",
            "ERROR": "There was an error adding response guidelines, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Response Guidelines updated successfully",
            "ERROR": "There was an error updating response guidelines, please try again."
          },
          "DELETE": {
            "SUCCESS": "Response Guidelines deleted successfully",
            "ERROR": "There was an error deleting response guidelines, please try again."
          }
        }
      },
      "SCENARIOS": {
        "TITLE": "Scenarios",
        "DESCRIPTION": "Give your assistant some context—like “what to do when a user is stuck,” or “how to act during a refund request.”",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Delete"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example scenarios",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "TOOLS_USED": "Tools used :"
          },
          "NEW": {
            "CREATE": "Add a scenario",
            "TITLE": "Create a scenario",
            "FORM": {
              "TITLE": {
                "LABEL": "Title",
                "PLACEHOLDER": "Enter a name for the scenario",
                "ERROR": "Scenario name is required"
              },
              "DESCRIPTION": {
                "LABEL": "Description",
                "PLACEHOLDER": "Describe how and where this scenario will be used",
                "ERROR": "Scenario description is required"
              },
              "INSTRUCTION": {
                "LABEL": "How to handle",
                "PLACEHOLDER": "Describe how and where this scenario will be handled",
                "ERROR": "Scenario content is required"
              },
              "CREATE": "Create",
              "CANCEL": "Cancel"
            }
          }
        },
        "UPDATE": {
          "CANCEL": "Cancel",
          "UPDATE": "Update changes"
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Iskanje ..."
        },
        "EMPTY_MESSAGE": "No scenarios found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No scenarios found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Scenarios added successfully",
            "ERROR": "There was an error adding scenarios, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Scenarios updated successfully",
            "ERROR": "There was an error updating scenarios, please try again."
          },
          "DELETE": {
            "SUCCESS": "Scenarios deleted successfully",
            "ERROR": "There was an error deleting scenarios, please try again."
          }
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Dokumenti",
      "ADD_NEW": "Ustvari nov dokument",
      "FAQ_COUNT": "{n} FAQ | {n} FAQs",
      "SELECTED": "{count} izbranih",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "BULK_DELETE_BUTTON": "Delete",
      "BULK_SYNC_BUTTON": "Refresh",
      "BULK_DELETE": {
        "TITLE": "Delete documents?",
        "DESCRIPTION": "Are you sure you want to delete the selected documents? This action cannot be undone.",
        "CONFIRM": "Da, izbriši vse",
        "SUCCESS_MESSAGE": "Documents deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the documents, please try again."
      },
      "BULK_SYNC": {
        "SUCCESS_MESSAGE_ONE": "Refresh queued for 1 document",
        "SUCCESS_MESSAGE": "Refresh queued for {count} documents",
        "ZERO_MESSAGE": "No documents marked for refresh.",
        "ERROR_MESSAGE": "There was an error queuing the refresh, please try again."
      },
      "SYNC": {
        "QUEUED_MESSAGE": "Refresh queued. We'll update the document shortly.",
        "ERROR_MESSAGE": "Could not queue refresh, please try again."
      },
      "FILTERS": {
        "SOURCE": {
          "ALL": "All sources",
          "WEB": "Web pages",
          "PDF": "PDFs"
        },
        "STATUS": {
          "ANY": "Any status",
          "UPDATED": "Updated",
          "NEEDS_UPDATE": "Needs update",
          "UPDATING": "Updating",
          "FAILED": "Neuspešno"
        },
        "SORT": {
          "RECENTLY_UPDATED": "Recently updated",
          "RECENTLY_CREATED": "Recently created"
        },
        "SEARCH_PLACEHOLDER": "Iskanje ..."
      },
      "SYNC_STATUS": {
        "SYNCED": "last updated {time}",
        "SYNCING": "updating...",
        "STALE_SYNC": "update stalled",
        "FAILED": "Failed to sync",
        "NEVER_SYNCED": "not updated yet"
      },
      "SYNC_ERRORS": {
        "NOT_FOUND": "Stran ni najdena",
        "ACCESS_DENIED": "Access denied",
        "TIMEOUT": "Page took too long to respond",
        "CONTENT_EMPTY": "Page returned empty content",
        "FETCH_FAILED": "Could not fetch page",
        "SYNC_ERROR": "Unexpected error",
        "DEFAULT": "Sync error"
      },
      "RELATED_RESPONSES": {
        "TITLE": "Povezana pogosta vprašanja",
        "EMPTY": "No FAQs have been generated from this document yet."
      },
      "DETAILS": {
        "DESCRIPTION": "Review the crawled content and the FAQs generated from this source.",
        "SOURCE": "Source",
        "GENERATED_FAQS": "Generated FAQs",
        "LAST_UPDATED": "Last updated",
        "NOT_AVAILABLE": "Not available",
        "CONTENT_TAB": "Crawled content",
        "PDF_TAB": "PDF details",
        "CONTENT_TITLE": "Crawled content",
        "PDF_TITLE": "PDF file",
        "PDF_DESCRIPTION": "Review the original PDF source.",
        "CHARACTER_COUNT": "{count} characters extracted",
        "COPY_CONTENT": "Kopiraj",
        "COPY_SUCCESS": "Crawled content copied to clipboard",
        "COPY_ERROR": "Could not copy crawled content",
        "VIEW_RAW": "View raw",
        "VIEW_PREVIEW": "View preview",
        "UNREADABLE_CONTENT": "Readable content could not be extracted from this document. You can view the raw extracted content.",
        "EMPTY_CONTENT": "No crawled content is available for this document yet."
      },
      "FORM_DESCRIPTION": "Vnesite URL dokumenta, da ga dodate kot vir znanja, in izberite asistenta, s katerim ga želite povezati.",
      "CREATE": {
        "TITLE": "Dodaj dokument",
        "SUCCESS_MESSAGE": "Dokument je bil uspešno ustvarjen",
        "ERROR_MESSAGE": "Pri ustvarjanju dokumenta je prišlo do napake, prosimo, poskusite znova."
      },
      "FORM": {
        "TYPE": {
          "LABEL": "Document Type",
          "URL": "URL",
          "PDF": "PDF File"
        },
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Vnesite URL dokumenta",
          "ERROR": "Prosimo, vnesite veljaven URL dokumenta"
        },
        "PDF_FILE": {
          "LABEL": "PDF File",
          "CHOOSE_FILE": "Choose PDF file",
          "ERROR": "Please select a PDF file",
          "HELP_TEXT": "Maximum file size: 10MB",
          "INVALID_TYPE": "Please select a valid PDF file",
          "TOO_LARGE": "File size exceeds 10MB limit"
        },
        "NAME": {
          "LABEL": "Document Name (Optional)",
          "PLACEHOLDER": "Enter a name for the document"
        }
      },
      "DELETE": {
        "TITLE": "Ste prepričani, da želite izbrisati dokument?",
        "DESCRIPTION": "Ta dejanje je trajno. Brisanje tega dokumenta bo trajno izbrisalo vse ustvarjeno znanje.",
        "CONFIRM": "Da, izbriši",
        "SUCCESS_MESSAGE": "Dokument je bil uspešno izbrisan",
        "ERROR_MESSAGE": "Pri brisanju dokumenta je prišlo do napake, prosimo, poskusite znova."
      },
      "OPTIONS": {
        "VIEW_DETAILS": "Poglej podrobnosti",
        "SYNC_NOW": "Refresh now",
        "RETRY_SYNC": "Retry refresh",
        "DELETE_DOCUMENT": "Izbriši dokument"
      },
      "EMPTY_STATE": {
        "TITLE": "Ni na voljo dokumentov",
        "SUBTITLE": "Dokumenti se uporabljajo za generiranje FAQ vašega asistenta. Dokumente lahko uvozite, da zagotovite kontekst za vašega asistenta.",
        "FILTERED_TITLE": "No matching documents",
        "FILTERED_SUBTITLE": "Try changing the source, status, or search term.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "CUSTOM_TOOLS": {
      "HEADER": "Tools",
      "ADD_NEW": "Create a new tool",
      "SOFT_LIMIT_WARNING": "Having more than 10 tools may reduce the assistant's reliability in selecting the right tool. Consider removing unused tools for better results.",
      "EMPTY_STATE": {
        "TITLE": "No custom tools available",
        "SUBTITLE": "Create custom tools to connect your assistant with external APIs and services, enabling it to fetch data and perform actions on your behalf.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Custom Tools",
          "NOTE": "Custom tools allow your assistant to interact with external APIs and services. Create tools to fetch data, perform actions, or integrate with your existing systems to enhance your assistant's capabilities."
        }
      },
      "FORM_DESCRIPTION": "Configure your custom tool to connect with external APIs",
      "OPTIONS": {
        "EDIT_TOOL": "Edit tool",
        "DELETE_TOOL": "Delete tool"
      },
      "CREATE": {
        "TITLE": "Create Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool created successfully",
        "ERROR_MESSAGE": "Failed to create custom tool"
      },
      "EDIT": {
        "TITLE": "Edit Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool updated successfully",
        "ERROR_MESSAGE": "Failed to update custom tool"
      },
      "DELETE": {
        "TITLE": "Delete Custom Tool",
        "DESCRIPTION": "Are you sure you want to delete this custom tool? This action cannot be undone.",
        "CONFIRM": "Da, izbriši",
        "SUCCESS_MESSAGE": "Custom tool deleted successfully",
        "ERROR_MESSAGE": "Failed to delete custom tool"
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use tools with Captain",
        "AVAILABLE_ON": "Captain Tools are only available in Business and Enterprise plans. Please upgrade to Business plan to use the feature.",
        "UPGRADE_PROMPT": "",
        "UPGRADE_NOW": "Open billing",
        "CANCEL_ANYTIME": ""
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Captain Tools are only available in the paid plans.",
        "UPGRADE_PROMPT": "Please upgrade to a paid plan to use this feature.",
        "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
      },
      "TEST": {
        "BUTTON": "Test connection",
        "SUCCESS": "Endpoint returned HTTP {status}",
        "ERROR": "Connection failed",
        "DISABLED_HINT": "Testing is only available for endpoints without templates or request bodies."
      },
      "FORM": {
        "TITLE": {
          "LABEL": "Tool Name",
          "PLACEHOLDER": "Order Lookup",
          "ERROR": "Tool name is required",
          "MAX_LENGTH_ERROR": "Tool name must be {max} characters or fewer"
        },
        "DESCRIPTION": {
          "LABEL": "Description",
          "PLACEHOLDER": "Looks up order details by order ID"
        },
        "HTTP_METHOD": {
          "LABEL": "Method"
        },
        "ENDPOINT_URL": {
          "LABEL": "Endpoint URL",
          "PLACEHOLDER": "https://api.example.com/orders/{'{{'} order_id {'}}'}",
          "ERROR": "Valid URL is required"
        },
        "AUTH_TYPE": {
          "LABEL": "Authentication Type"
        },
        "AUTH_TYPES": {
          "NONE": "None",
          "BEARER": "Bearer Token",
          "BASIC": "Basic Auth",
          "API_KEY": "API Key"
        },
        "AUTH_CONFIG": {
          "BEARER_TOKEN": "Bearer Token",
          "BEARER_TOKEN_PLACEHOLDER": "Enter your bearer token",
          "USERNAME": "Username",
          "USERNAME_PLACEHOLDER": "Enter username",
          "PASSWORD": "Geslo",
          "PASSWORD_PLACEHOLDER": "Enter password",
          "API_KEY": "Header Name",
          "API_KEY_PLACEHOLDER": "X-API-Key",
          "API_VALUE": "Header Value",
          "API_VALUE_PLACEHOLDER": "Enter API key value"
        },
        "PARAMETERS": {
          "LABEL": "Parameters",
          "HELP_TEXT": "Define the parameters that will be extracted from user queries"
        },
        "ADD_PARAMETER": "Add Parameter",
        "PARAM_NAME": {
          "PLACEHOLDER": "Parameter name (e.g., order_id)"
        },
        "PARAM_TYPE": {
          "PLACEHOLDER": "Type"
        },
        "PARAM_TYPES": {
          "STRING": "String",
          "NUMBER": "Številka",
          "BOOLEAN": "Boolean",
          "ARRAY": "Array",
          "OBJECT": "Object"
        },
        "PARAM_DESCRIPTION": {
          "PLACEHOLDER": "Description of the parameter"
        },
        "PARAM_REQUIRED": {
          "LABEL": "Required"
        },
        "REQUEST_TEMPLATE": {
          "LABEL": "Request Body Template (Optional)",
          "PLACEHOLDER": "{'{'}\n  \"order_id\": \"{'{{'} order_id {'}}'}\"\n{'}'}"
        },
        "RESPONSE_TEMPLATE": {
          "LABEL": "Response Template (Optional)",
          "PLACEHOLDER": "Order {'{{'} order_id {'}}'} status: {'{{'} status {'}}'}"
        },
        "ERRORS": {
          "PARAM_NAME_REQUIRED": "Parameter name is required"
        }
      }
    },
    "RESPONSES": {
      "HEADER": "Pogosta vprašanja",
      "PENDING_FAQS": "Pending FAQs",
      "ADD_NEW": "Ustvari nov FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Pogovor #{id}"
      },
      "SELECTED": "{count} izbranih",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "SEARCH_PLACEHOLDER": "Search FAQs...",
      "BULK_APPROVE_BUTTON": "Odobri",
      "BULK_DELETE_BUTTON": "Izbriši",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "Pogosta vprašanja so bila uspešno odobrena",
        "ERROR_MESSAGE": "Pri odobritvi pogostih vprašanj je prišlo do napake, prosimo, poskusite znova."
      },
      "BULK_DELETE": {
        "TITLE": "Izbrisati pogosta vprašanja?",
        "DESCRIPTION": "Ali ste prepričani, da želite izbrisati izbrane pogosta vprašanja? Tega dejanja ni mogoče razveljaviti.",
        "CONFIRM": "Da, izbriši vse",
        "SUCCESS_MESSAGE": "Pogosta vprašanja so bila uspešno izbrisana",
        "ERROR_MESSAGE": "Pri brisanju pogostih vprašanj je prišlo do napake, prosimo, poskusite znova."
      },
      "DELETE": {
        "TITLE": "Ste prepričani, da želite izbrisati pogosta vprašanja?",
        "DESCRIPTION": "",
        "CONFIRM": "Da, izbriši",
        "SUCCESS_MESSAGE": "Pogosta vprašanja so bila uspešno izbrisana",
        "ERROR_MESSAGE": "Pri brisanju pogostih vprašanj je prišlo do napake, prosimo, poskusite znova."
      },
      "FILTER": {
        "ASSISTANT": "Pomočnik: {selected}",
        "STATUS": "Stanje: {selected}",
        "ALL_ASSISTANTS": "Vse"
      },
      "STATUS": {
        "TITLE": "Stanje",
        "PENDING": "V teku",
        "APPROVED": "Odobreno",
        "ALL": "Vse"
      },
      "PENDING_BANNER": {
        "TITLE": "Captain has found some FAQs your customers were looking for.",
        "ACTION": "Click here to review"
      },
      "FORM_DESCRIPTION": "Dodajte vprašanje in njegov ustrezen odgovor v bazo znanja ter izberite asistenta, s katerim naj bo povezano.",
      "CREATE": {
        "TITLE": "Dodaj pogosta vprašanja",
        "SUCCESS_MESSAGE": "Odgovor je bil uspešno dodan.",
        "ERROR_MESSAGE": "Pri dodajanju odgovora je prišlo do napake. Poskusite znova."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Vprašanje",
          "PLACEHOLDER": "Vnesite vprašanje tukaj",
          "ERROR": "Prosimo, vnesite veljavno vprašanje."
        },
        "ANSWER": {
          "LABEL": "Odgovor",
          "PLACEHOLDER": "Vnesite odgovor tukaj",
          "ERROR": "Prosimo, vnesite veljaven odgovor."
        }
      },
      "EDIT": {
        "TITLE": "Posodobi pogosta vprašanja",
        "SUCCESS_MESSAGE": "Pogosta vprašanja so bila uspešno posodobljena",
        "ERROR_MESSAGE": "Prišlo je do napake pri posodabljanju pogostih vprašanj, prosimo, poskusite znova",
        "APPROVE_SUCCESS_MESSAGE": "Pogosta vprašanja so bila označena kot odobrena"
      },
      "OPTIONS": {
        "APPROVE": "Approve",
        "EDIT_RESPONSE": "Edit",
        "DELETE_RESPONSE": "Delete"
      },
      "EMPTY_STATE": {
        "TITLE": "Ni najdenih pogostih vprašanj",
        "NO_PENDING_TITLE": "There are no more pending FAQs to review",
        "SUBTITLE": "Pogosta vprašanja pomagajo vašemu asistentu hitro in natančno odgovarjati na vprašanja vaših strank. Lahko se samodejno ustvarijo iz vaše vsebine ali pa jih dodate ročno.",
        "CLEAR_SEARCH": "Clear active filters",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Povezani nabiralniki",
      "ADD_NEW": "Poveži nov nabiralnik",
      "OPTIONS": {
        "DISCONNECT": "Prekini povezavo"
      },
      "DELETE": {
        "TITLE": "Ali ste prepričani, da želite prekiniti povezavo z nabiralnikom?",
        "DESCRIPTION": "",
        "CONFIRM": "Da, izbriši",
        "SUCCESS_MESSAGE": "Nabiralnik je bil uspešno prekinjen.",
        "ERROR_MESSAGE": "Prišlo je do napake pri odklopu poštnega predala, prosimo, poskusite znova."
      },
      "FORM_DESCRIPTION": "Izberite poštni predal za povezavo z asistentom.",
      "CREATE": {
        "TITLE": "Poveži poštni predal",
        "SUCCESS_MESSAGE": "Poštni predal je bil uspešno povezan.",
        "ERROR_MESSAGE": "Pri povezovanju poštnega predala je prišlo do napake. Prosimo, poskusite znova."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Nabiralnik",
          "PLACEHOLDER": "Izberite prejemnik za namestitev asistenta.",
          "ERROR": "Izbira prejemnika je obvezna."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Ni povezanih poštnih predalov",
        "SUBTITLE": "Povezava z nabiralnikom omogoča asistentu, da obravnava začetna vprašanja vaših strank, preden jih preusmeri k vam."
      }
    }
  }
}
